import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DocumentType, EventType} from '@app/shared';
import {FormArray} from '@angular/forms';
import {FlowEventService} from '@app/core';
import {CdkDragDrop} from '@angular/cdk/drag-drop';
import {GlobalValuesService} from '../../../core/services/global-values.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-event-cards-dragables',
  standalone: false,

  templateUrl: './flow-event-card.component.html',
  styleUrl: './flow-event-card.component.less'
})
export class FlowEventCardComponent {

  @Input() events!: FormArray;
  @Input() isEditing: boolean = true;

  @Output() openAddOrEditEvent = new EventEmitter<number | null>();

  documentTypes: DocumentType[] = [];

  constructor(private flowEventService: FlowEventService, public gs: GlobalValuesService) {
    this.gs.documentTypes$.pipe(takeUntilDestroyed())
      .subscribe((value) => {
        this.documentTypes = value;
      })
  }

  drop(event: CdkDragDrop<any[]>): void {
    this.flowEventService.drop(event, this.events as FormArray);
  }

  getValue(value: any): string {
    if (typeof value === 'number') {
      return this.documentTypes.find(dt => dt.id === value)?.name || '-';
    } else {
      return value;
    }
  }

  removeEvent(index: number): void {
    this.flowEventService.removeEvent(index, this.events);
  }

  isSpecialEvent(event: EventType): boolean {
    return event.name === 'Orden creada' || event.name === 'Orden finalizada';
  }
}
